import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { SchoolClassService } from '../../../../../services/school-class.service';
import { ApplicationStateService } from '../../../../../services/application-state.service';
import { Subscription } from 'rxjs';
import { ModalComponent } from '../../../../../models/modal-component';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-class-sharing-modal',
    templateUrl: './class-sharing-modal.component.html',
    imports: [
        FormsModule
    ],
    styleUrls: ['./class-sharing-modal.component.scss']
})

export class ClassSharingModalComponent extends ModalComponent implements OnInit, OnDestroy {
    static MODAL_ID = 'classSharingModal';
    @ViewChild('classSelect') classSelect: ElementRef;
    @ViewChild('modalElement') modalElement: ElementRef;
    class?: number = null;
    title: string;
    message: string;
    link: string;
    protected subscription: Subscription;
    errMsg: string

    constructor(public schoolClassService: SchoolClassService,
                public applicationStateService: ApplicationStateService
    ) {
        super();
    }

    ngOnInit(): void {
        this.schoolClassService.init();
        this.subscription = this.schoolClassService.sharingLink$.subscribe((value) => {
            this.message = value;
        });
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    getId(): string {
        return ClassSharingModalComponent.MODAL_ID;
    }

    notify(): void {
        if (!this.class) {
            this.classSelect.nativeElement.classList.add('invalid');

            return;
        }
        this.schoolClassService.notifyClass(
            this.class,
            this.title,
            this.message
        )
            .then(response => {
                this.classSelect.nativeElement.classList.remove('invalid');
                this.modalElement.nativeElement.modal('hide');
            })
            .catch((err) => {
                if (err.status === 422 && err.detail) {
                    this.errMsg = err.detail;
                } else if (err.message) {
                    this.errMsg = err.message;
                } else {
                    this.errMsg = 'Fehler beim Senden der Benachrichtigung.';
                }
            });
    }
}
